import DriverPage from "../Fleet/DriverPage";

const OperationsDriversPage = () => {
  return <DriverPage />;
};

export default OperationsDriversPage;
